import { SearchType } from "@domain/enums/SearchType";

export const SEARCH_TYPE_TO_PREFIX_SEARCH_URL: Map<SearchType, string> = new Map(
	[
		[SearchType.PROGRAMME_SEARCH, ''],
		[SearchType.UNIVERSITY_SEARCH, '/universities'],
		[SearchType.SCHOLARSHIP_SEARCH, '/scholarships']
	]
)